// css =>
import "../../BaseStructure.css";
import Styled from "./MainPage.module.css";

// componenets =>
import Fotter from "../../Components/fotter/fotter.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import StoryViewer from '../../Components/storyViewer/storyViewer.comp';
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";
import MainPageMenuBar from "../../Components/mainPageMenuBar/mainPageMenuBar.comp";

// icons =>
import InstaIcon from "../../Assets/Icons/insta.png";
import EmailIcon from "../../Assets/Icons/email.png";
import PhoneIcon from "../../Assets/Icons/phone.png";
import SlashIcon from "../../Assets/Icons/slashs.png";
import LocationIcon from "../../Assets/Icons/location.png";

// pic =>
import TestPicOne from "../../Assets/Pictures/2.png";
import TestPicTwo from "../../Assets/Pictures/3.png";
import TestPicFour from "../../Assets/Pictures/6.png";
import TestPicFive from "../../Assets/Pictures/7.png";
import TestPicSix from "../../Assets/Pictures/11.png";
import TestPicThree from "../../Assets/Pictures/4.png";
import StoryThumbnail from "../../Assets/Pictures/8.png";
import NotImage from "../../Assets/Pictures/No_Image.png";

// react =>
import { useState, useEffect, useRef } from "react";

// API =>
import backEnd from "../../services/Api";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

// type =>
import { PRODUCT_LIST_RESPONSE, PRODUCT_LIST_ITEM, Story } from "./MainPageType";

// service =>
import { handleCloseAndPauseStory, handlePlay, handlePause, handleApiError, fetchStories } from "./MainPageService";

// store =>
import { useUserStore } from "../../hooks/useUserStore";
import MenuBar from "../../Components/menuBar/menuBar.comp";

function MainPage() {

    const { showMessage } = useMessage();

    const [open, setOpen] = useState(false);
    const [storyList, setStoryList] = useState<Story[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [isLoadingStories, setIsLoadingStories] = useState(true);

    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    const [isLoadingGiftAndStoryList, setIsLoadingGiftAndStoryList] = useState(true);
    const [giftAndStoryList, setGiftAndStoryList] = useState<PRODUCT_LIST_RESPONSE | null>(null);

    useEffect(() => {
        document.title = "فروشگاه چرم ویدوک | خرید کیف و کفش چرمی";

        backEnd.get(`users/profile-get/${ useUserStore.getState().user?.id }/`).then(( result ) => {
            setIsAuthenticated(true);
        }).catch(( error ) => {
            setIsAuthenticated(false);

            if (error.status !== 404) {
                showMessage("error", "خطا در دریافت اطلاعات لطفا مجددا وارد حساب خود شوید!");
            }

            useUserStore.getState().setUser(null);
            localStorage.removeItem("user-storage");
        })

        backEnd.get("products/get-products-list/?limit=5").then(( result ) => {
            setGiftAndStoryList(result.data);
            setIsLoadingGiftAndStoryList(false);
        }).catch(( error ) => {
            const errorMessage = handleApiError(error);
            setIsLoadingGiftAndStoryList(false);
            showMessage("error", errorMessage);
        });

        const loadStories = async () => {
            const result = await fetchStories();

            if (result.status) {
                setStoryList(result.data);
            } else {
                setStoryList([]);
                if (result.message) {
                    showMessage("error", result.message);
                }
            }

            setIsLoadingStories(false);
        };

        loadStories();
    }, []);

    return (
        <>
            <div>
                {
                    open && (
                        <StoryViewer
                            stories={ storyList.map(story => ({ ...story, username: "wedook" })) }
                            initialIndex={ currentIndex }
                            onClose={() => setOpen(false)}
                        />
                    )
                }
            </div>

            <MainPageMenuBar key={ 0 } isAuthenticated={ isAuthenticated } />
            <MobileMenuBar isAuthenticated={ isAuthenticated } />

            {
                isLoadingStories ? (
                    <>
                        <br />
                        <SpinnerBar />
                        <br /><br />
                    </>
                ) : (
                    <div className="row" id={ Styled.StoryBoxFrame } data-aos="fade-up">
                        {
                            storyList && storyList.length > 0 ? (
                                <>
                                    {
                                        storyList?.map((story: Story, index: number) => {
                                            return <div
                                                        key={ story.id }
                                                        className={`col-1 ${ Styled.StoryBox }`}
                                                        onClick={(e) => {
                                                            e.currentTarget.style.borderColor = "gray";
                                                            setCurrentIndex(index);
                                                            setOpen(true);
                                                        }}
                                                    >
                                                        <img src={ StoryThumbnail } alt="Story" />
                                                    </div>
                                            }
                                        )
                                    }

                                    <div className="col-12" id={ Styled.StoryBoxBackground } data-aos="fade-up"></div>
                                </>
                            ) : null
                        }
                    </div>
                )
            }

            <div className="row" id={ Styled.CategoryFrame } data-aos="fade-up">
                <div className={`col-12 ${ Styled.FirstWedookTextFrame } `}>
                    <span>W</span>
                    <span>e</span>
                    <span> </span>
                    <span>D</span>
                    <span>o</span>
                    <span>o</span>
                    <span>k</span>
                </div>
                <div className="col-12">
                    <span>Clothing</span>
                    <span>Shoes</span>
                    <span>Bag</span>
                    <span>Luggage</span>
                    <span>Accessories</span>
                </div>
            </div>

            <div className={`row ${ Styled.SmallFrame } `} id={ Styled.MainBannerFrame }>
                <div className="col-12">
                    <img src={ TestPicThree } alt="بنر اصلی" />
                </div>
            </div>

            <div className="col-12" id={ Styled.ProductBoxBackground } data-aos="fade-up"></div>
            <div className="row" id={ Styled.ProductBoxFrame } data-aos="fade-up">
                <div className="col-2">
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
                <div className="col-2">
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
                <div className="col-2">
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
                <div className="col-2">
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
                <div className="col-2">
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
            </div>

            <div className={`row ${ Styled.SmallFrame } ${ Styled.SectionTittleFrameBox } `} data-aos="fade-up">
                <div className={`col-12 ${ Styled.SectionTittleFrame } `}>
                    <h1>جدید ترین و به روز ترین محصولات چرمی</h1>
                </div>
            </div>

            <div className={`row ${ Styled.SmallFrame } `} data-aos="fade-up" style={{ marginBottom: "110px" }}>
                <div className="col-6" id={ Styled.ProductGenderBannerFrame }>
                    <img src={ TestPicThree } alt="" loading="lazy" />
                </div>

                <div className={`col-3 ${ Styled.ProductGenderFrame } `}>
                    <img src={ TestPicTwo } alt="" loading="lazy" />
                    <p>برای خانوم ها</p>
                </div>
                <div className={`col-3 ${ Styled.ProductGenderFrame } `}>
                    <img src={ TestPicTwo } alt="" loading="lazy" />
                    <p>برای آقایان</p>
                </div>
            </div>

            <div className={`row ${ Styled.SectionTittleFrameBox } `} data-aos="fade-up">
                <div className={`col-12 ${ Styled.SectionTittleFrame } `}>
                    <h1>ست ها و هدایا</h1>

                    <div>
                        <p>مشاهده ی همه و خرید</p>
                        <img src={ SlashIcon } alt="" />
                    </div>
                </div>
            </div>

            {
                isLoadingGiftAndStoryList ? (
                    <>
                        <br /><br />
                        <SpinnerBar />
                        <br /><br />
                    </>
                ) : (
                    <div className={`row ${ Styled.SmallFrame } `} data-aos="fade-up">
                        <div className="col-5" id={ Styled.GiftAndStoryBigBannerFrame }>
                            <img src={ TestPicFour } alt="" loading="lazy" />
                        </div>

                        <div className={`col-7 ${ Styled.GiftAndStorySmallBannerFrameBox } `}>
                            {
                                giftAndStoryList?.results.map(( item: PRODUCT_LIST_ITEM ) => {
                                    return <div key={ item.id }>
                                        <img src={ item.thumbnail || NotImage } alt="ست ها و هدایا" loading="lazy" />
                                    </div>
                                })
                            }
                        </div>
                    </div>
                )
            }

            {/* <div className={`row ${ Styled.SmallFrame } `} data-aos="fade-up">
                <div className="col-12" id={ Styled.GalleryBannerFrame }>
                    <img src={ TestPicFive } alt="Gallry" />
                </div>
            </div> */}

            <div className={`row ${ Styled.SmallFrame } ${ Styled.SmallFrameDesktop } `} data-aos="fade-up" style={{ marginTop: '50px' }}>
                <div className="col-4" id={ Styled.NewsBoxText }>
                    <div className="col-12">
                        <h2>به روز باشید!</h2>
                    </div>
                    <div className="col-12">
                        <h3>ترند ترین کیف های 2026</h3>
                    </div>
                    <div className="col-12" id={ Styled.SliderBox }>
                        <div className="col-1"></div>
                        <div className="col-1" style={{ backgroundColor: 'rgb(255, 127, 0)' }}></div>
                        <div className="col-1"></div>
                    </div>
                </div>
                <div className="col-8" id={ Styled.NewsBoxBanner }></div>
            </div>

            <div className={`row ${ Styled.SmallFrameMobile } `} data-aos="fade-up" style={{ marginTop: '50px' }}>
                <div className="col-12">
                    <h2>به روز باشید!</h2>
                </div>
                <div className="col-10" id={ Styled.SmallFrameMobileContent }>
                    <h3>ترند ترین کیف های 2026</h3>
                    <p>فروش کیف و کفش و چرم و فروش کیف و کفش و چرم و فروش کیف و کفش و چرم و فروش کیف و کفش و چرم و </p>
                </div>
                <div className="col-2" id={ Styled.SmallFrameMobileImage }>
                    <img src={ TestPicOne } alt="" loading="lazy" />
                </div>
            </div>

            {/* <div className={`row ${ Styled.SmallFrame } `} data-aos="fade-up">
                <div className="col-12" id={ Styled.LastBannerFrame }>
                    <img src={ TestPicSix } alt="" />
                </div>
            </div> */}

            <div className={`row ${ Styled.SectionTittleFrameBox } `} data-aos="fade-up">
                <div className={`col-12 ${ Styled.SectionTittleFrame } `}>
                    <h1>ویدوک</h1>

                    <div>
                        <p>مطالعه درباره ی برند</p>
                        <img src={ SlashIcon } alt="" />
                    </div>
                </div>
            </div>

            <div className={`row ${ Styled.SmallFrame } `} id={ Styled.AboutWedookBox } data-aos="fade-up">
                <div className="col-12" id={ Styled.AboutWedookHeader }>
                    <div className="col-3" id={ Styled.AboutWedookPicFrame }>
                        <img src={ TestPicOne } alt="" loading="lazy" />
                        .
                    </div>
                    <div className="col-9" id={ Styled.AboutWedookHeaderTextFrame }>
                        <br />
                        <h1>مجموعه ی تولید و صادرات ویدوک</h1>
                        <p>مدیر عامل برند : دکتر سوسن محمدی</p>
                    </div>
                </div>

                <div style={{ marginTop: '3%' }}>
                    <p>مجموعه تولید و صادرات مصنوعات چرمی طبیعی برند ویدوک فعالیت خود را در سال 1369 از آموزش بعد کارآفرینی و تولید در شهر ارومیه آغاز نمود.</p>
                    <p>احترام به مشتری و فعالیت نیروهای کارآمد و برنامه ریزی دقیق جهت تولید و صادرات محصولات چرم طبیعی به همراه حمایت مشتریان گرانقدر باعث شد تا برند بین المللی ویدوک جزو بهترین و ارزشمند ترین مجموعه های فعال و کارآفرینی در این حوزه باشد.</p>
                    <p>در طی سال های حضور با پاسخگویی ، مسئولیت پذیری و مشتری مداری و همچنین طراحی ، تولید و صادرات محصولات با کیفیت از جمله : کیف و کفش و تمامی</p>
                </div>
            </div>

            <div className="row" style={{ marginTop: "50px" }} data-aos="fade-up">
                <div className={`col-12 ${ Styled.SectionTittleFrame } `}>
                    <h1>ارتباط با ما</h1>
                </div>
            </div>

            <div className={`row ${ Styled.SmallFrame } `} data-aos="fade-up">
                <a href="https://www.instagram.com/we_dook_brand?igsh=MXNwMmtueHo2bWt0eg==">
                    <div className={`col-3 ${ Styled.ConnectionWayBoxFrame }`}>
                        <div className={`col-9 ${ Styled.ConnectionWayText } `}>
                            <p className={ Styled.ConnectionWayEnglishText }>wedook leather</p>
                        </div>
                        <div className={`col-3 ${ Styled.ConnectionWayIcon } `}>
                            <img src={ InstaIcon } alt="Instagram" />
                        </div>
                    </div>
                </a>

                <a href="mailto:wedook.leather@gmail.com">
                    <div className={`col-3 ${ Styled.ConnectionWayBoxFrame }`}>
                        <div className={`col-9 ${ Styled.ConnectionWayText } `}>
                            <p className={ Styled.ConnectionWayEnglishText }>wedook.leather@gmail.com</p>
                        </div>
                        <div className={`col-3 ${ Styled.ConnectionWayIcon } `}>
                        <img src={ EmailIcon } alt="Email" /></div>
                    </div>
                </a>

                <a href="tel:09336082855">
                    <div className={`col-3 ${ Styled.ConnectionWayBoxFrame }`}>
                        <div className={`col-9 ${ Styled.ConnectionWayText } `}>
                            <p>09141234567</p>
                        </div>
                        <div className={`col-3 ${ Styled.ConnectionWayIcon } `}>
                            <img src={ PhoneIcon } alt="Phone" />
                        </div>
                    </div>
                </a>

                <a href="https://maps.google.com/?q=ارومیه+خیابان+رودکی" target="_blank" rel="noopener noreferrer">
                    <div className={`col-3 ${ Styled.ConnectionWayBoxFrame }`}>
                        <div className={`col-9 ${ Styled.ConnectionWayText } `}>
                            <p>ارومیه . خیابان رودکی</p>
                        </div>
                        <div className={`col-3 ${ Styled.ConnectionWayIcon } `}>
                            <img src={ LocationIcon } alt="location" />
                        </div>
                    </div>
                </a>
            </div>

            <br /><br />

            <div id={ Styled.MenuBarFrame }>
                <MenuBar />
            </div>

            <Fotter />

            <br /><br /><br />
        </>
    );
};

export default MainPage;
